import React from 'react';
import { Trans } from 'react-i18next';
import LoaderSvg from "../../assets/img/load.svg";
export default function submitButton(props) {
    return (React.createElement("button", { type: 'submit', className: "small-12 form-element form-button " + (props.disabled ? 'disabled' : '') + " radius" },
        React.createElement(Trans, null, "Abschicken"),
        " \u00A0",
        props.isLoading ? React.createElement("img", { alt: "loading...", width: "20", height: "20", src: LoaderSvg }) : React.createElement(React.Fragment, null)));
}
